import Vue from 'vue';

function minLength(length: number) {
  return (v: string) => {
    if (typeof v !== 'string') {
      return 'Require Text';
    }
    if (v.length >= length) {
      return true;
    }
    return `Require Lengs: ${length}`;
  };
}

function ipAddress(v: string) {
  if (!/^\d+\.\d+\.\d+\.\d+$/.test(v)) {
    return false;
  }

  return v.split('.').every((str) => {
    const val = parseInt(str, 10);
    return val >= 0 && val <= 255;
  });
}

function serverAddress(v: string) {
  if (/^([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/.test(v)) {
    return true;
  }
  return ipAddress(v);
}

function numberRange(min: number, max: number) {
  return (val: number) => {
    if (typeof val !== 'number') {
      return 'Not a Number';
    }

    if (val >= min && val <= max) {
      return true;
    }
    return `${min} <= input <= ${max}`;
  };
}

function date(val: string) {
  const reg = /^([0-9]{1,})[-/]([0-9]{1,2})[-/]([0-9]{1,2})$/;
  if (!reg.test(val)) {
    return false;
  }
  const ret = val.match(reg);
  if (!ret || !ret.length || ret.length < 4) {
    return false;
  }
  const month = parseInt(ret[2], 10);
  const day = parseInt(ret[3], 10);
  if (month < 1 || month > 12) {
    return false;
  }
  if (day < 1 || day > 31) {
    return false;
  }

  return true;
}

function time(val: string) {
  const reg = /([0-9]{1,2}):([0-9]{1,2})$/;
  if (!reg.test(val)) {
    return false;
  }
  const ret = val.match(reg);
  if (!ret || !ret.length || ret.length < 3) {
    return false;
  }
  const hour = parseInt(ret[1], 10);
  const minut = parseInt(ret[2], 10);
  if (hour < 0 || hour > 24) {
    return false;
  }
  if (minut < 0 || minut > 60) {
    return false;
  }

  return true;
}

function required(val: unknown) {
  if (typeof val === 'string' && val.length > 0) {
    return true;
  }
  if (typeof val === 'number') {
    return true;
  }
  return 'Required';
}

function number(val: unknown) {
  if (typeof val === 'number') {
    return true;
  }
  return 'Require Number';
}

function email(val: unknown) {
  // eslint-disable-next-line no-useless-escape
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (typeof val !== 'string') {
    return 'Invalid Email Address';
  }
  if (reg.test(val)) {
    return true;
  }
  return 'Invalid Email Address';
}

function numberString(val: unknown) {
  if (val === undefined || val === null) {
    return true;
  }
  if (typeof val !== 'string') {
    return 'Require Number';
  }
  if (val === '') {
    return true;
  }
  if (!/^\d+$/.test(val)) {
    return 'Require Number';
  }
  return true;
}

function step(val: number, scale = 1, offset = 0, max?: number) {
  return (data: unknown) => {
    if (typeof data === 'number') {
      if (data === max) {
        return true;
      }

      if ((data * scale - offset) % val === 0) {
        return true;
      }
      return `${val / scale} Step.`;
    }
    return 'Not Number';
  };
}

function allowEmpty(func: (val: unknown) => boolean) {
  return (v: unknown) => {
    if (v === undefined || v === '') {
      return true;
    }
    return func(v);
  };
}

function install(vue: typeof Vue) {
  // eslint-disable-next-line no-param-reassign
  vue.prototype.$v = {
    ipAddress,
    minLength,
    serverAddress,
    numberRange,
    date,
    time,
    required,
    number,
    email,
    numberString,
    step,
    allowEmpty,
  };
}

export default {
  install,
};
